import { handleRequest } from "../utilities/requestHandler";

export const addProductsToRecommendationList = (listId, products) =>
    handleRequest("post", "/recommendations/products", {
        list_id: listId,
        products: products,
    });

export const saveRequestListBulk = (products) =>
    handleRequest("post", "/request_list/saverequestlist-bulk", {
        products: products,
    });